const isRenault = process.env.REACT_APP_BRAND === 'renault'

const BRAND = isRenault ? 'Renault' : 'Dacia'

const translation = {
    tr: {
        translation: {
            // Common
            pageTitle: `${BRAND} Servis Randevusu`,
            title: 'Online Servis Randevusu',
            darkMode: 'Karanlık Mod',
            lightMode: 'Aydınlık Mod',
            step0: 'Randevu Yöntemi',
            step1: 'Hizmetler',
            step2: 'Yetkili Servis',
            step3: 'Kişisel Bilgiler',
            step4: 'Onay',
            step5: '',
            UNKNOWN_ERROR: 'Bilinmeyen Hata',
            MAP_PERMISSION_ERROR: 'Konum alınamadı konuma izin vermelisiniz',
            nextButton: 'Devam Et',
            backButton: 'Geri',
            buttonChoose: 'Seç',
            startBtn: 'İleri',
            backButtonSms: 'Değiştir',
            takeAppointmentButton: 'Onayla',
            province: 'İl', // deprecated
            timeSlotSelect: 'Tarih',// deprecated
            // Form0
            appointmentMethod: 'Randevu Yöntemini Seçiniz',
            takeAppointment: 'Randevu Al',
            takeAppointmentExplain: 'Plaka/Şasi numarası girerek randevu alın',
            plateChassisInput: 'Plaka/Şasi Numarası',
            loginWithPort: 'Port ile randevu al',
            loginWithPortExplain: `${BRAND} Port kullanıcısı olduğunuz telefon numaranızı girin`,
            phone: 'Telefon Numarası',
            verifyButtonSms: 'Doğrula',
            plateChassisInputError: 'Lütfen Plaka veya Şasi numarası giriniz',
            chassisInputError: 'Şaşi numarası 17 haneden fazla olamaz',
            // Form1
            vehicleModel: 'Araç Modeli',
            vehicleError: 'Lütfen araç modelinizi seçiniz',
            km: 'KM Bilgisi',
            kmError: 'Lütfen aracınızın kilometresini giriniz',
            maintenance: 'Bakım yaptırmak istiyorum',
            vale: 'Kapında vale hizmeti istiyorum',
            valeDescription: 'Bu hizmet kapsamında aracınız istediğin konumdan alınarak, servis sonunda istediğiniz konuma teslim edilecektir. Yetkili servislerimiz sizden ücret talep edebilir',
            appointmentRequestsTitle: 'Servis İstekleri',
            appointmentRequestsError: 'Devam etmek için en az bir tane istek giriniz',
            micButtonText: 'Ya da Konuşarak Ekleyin',
            micRecordingText: 'Sesiniz işleniyor...',
            micErrorText: 'Konuşarak eklemek için mikrofona izin vermelisin',
            // Form2
            filter: 'Ara',
            filterHelperText: 'il, ilçe veya bayi adı',
            listView: 'Liste',
            mapView: 'Harita',
            nearby: 'Yakınımdakiler',
            filterTitle: 'Filtreler',
            filterVale: 'Kapında Vale Hizmeti',
            filterSeller: 'Yetkili Satıcı',
            filterService: 'Yetkili Servis',
            filterDakik: `${BRAND} Dakik Servis`,
            filterMekanik: 'Yetkili Mekanik Servis',
            chooseService: 'Servis Seçin',
            dealerError: 'Devam etmek için yetkili servis seçiniz',
            timeSlotError: 'Lütfen gün ve saat seçiniz',
            // Form3
            personalInfo: 'Kişisel Bilgiler',
            enterName: 'Ad',
            nameError: 'Lütfen adınızı girin',
            enterSurname: 'Soyad',
            surnameError: 'Lütfen soyadınızı girin',
            enterPhone: 'Telefon Numarası',
            enterEmail: 'E-posta',
            kvkkError: 'Kvkk metnini kabul etmelisiniz.',
            permission: 'ETK uyarınca tarafıma ticari elektronik ileti gönderilmesine onay verdiğimi kabul ediyorum.',
            permissionError: 'En az bir iletişim kanalı seçmelisiniz.',
            phonePermission: 'Telefon',
            smsPermission: 'SMS',
            emailPermission: 'E-posta',
            requestVale: 'Kapında vale hizmeti istiyor',
            valeSummry: 'Kapında Vale Hizmeti',
            maintenanceSummry: 'Bakım',
            vehicle: 'Araç',
            plate: 'Plaka',
            chassis: 'Şasi Numarası',
            emailError: 'Lütfen geçerli bir e-posta adresi girin',
            loginPortUserInfo: '* Kişisel bilgileriniz port hesabınızdaki bilgilerden alınmıştır.',
            // Form4 && Form0
            smsCode: 'Telefonunuza gelen doğrulama kodunu giriniz',
            smsCodeError: 'Lütfen telefonunuza gelen doğrulama kodunu giriniz',
            verifySmsAndFromButton: 'Doğrula ve Randevu Al',
            // Form5
            readQRCode: `Servis randevunuzu ${BRAND} Port üzerinden takip edebilirsiniz. İndirmek için kare kod'u okutun.`,
            appointmentSuccessMessage: 'Yetkili servis randevu talebiniz başarı ile oluşturulmuştur. Yetkili Servisimiz tarafından aranarak, randevunuz kesinleştirilecektir.',
            appointmentCancelMessage: 'Servis randevu talebiniz iptal edilmiştir',
            renaultSiteAddress: isRenault ? 'Renault.com.tr' : 'Dacia.com.tr',
            download: 'Portu İndir',
            returnToHomeButton: 'Başa Dön', // deprecated
            cancelAppointmentButton: 'Randevuyu İptal Et',// deprecated
            maisLibrary: 'Mais Kütüphane',
            maisLibraryText: '',
            // Summary
            dealerAddress: 'Adres',
            dealerPhone: 'Telefon',
            dealerName: 'Bayi',
            timeSlot: 'Randevu Tarihi',
            name: 'Ad',
            surname: 'Soyad',
            email: 'E-posta',
            phoneError: 'Lütfen telefonunuzu girin',
            contactPermission: 'İletişim İzni',
            // index
            summaryTitle: 'Özet',
            appointmentDetails: 'Randevu Detayları',
            date: 'Tarih',
            dealer: 'Yetkili Satıcı',
            vehicleInfo: 'Araç Bilgileri',
            serviceRequest: 'Servis İstekleri',
            appointmentCanceled: 'Randevunuz İptal Edildi',
            cancelAppointment: 'Randevuyu İptal Et',
            getRoute: 'Yol Tarifi Al',
            goToHomepage: 'Ana Sayfaya Dön',
        }
    },

    en: {
        translation: {
        }
    }
}

export default translation